import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { addBusinessDays, subBusinessDays } from 'date-fns';

import { get } from 'lodash';
import { FieldLabelWrapper, FieldWrapper } from './css';
import ManagedDatePicker from '../../common/ManagedDatePicker';
import FieldGuide from './common/fieldGuide';
import FieldTitle from './common/FieldTitle';
import { fieldIsThisAnEContractCustomer, fieldPreferredInstallationDate, fieldPreferredInstallDate, fieldPreferredInstallDate1, fieldPreferredInstallDate2, fieldPreferredInstallDate3, fieldWLSBusinessConnect, filedIsTheirAnyReasonToGoThroughMySOF, filedNeedMediaAdvertisingBilling, filedNeedMoreThanSingleServiceAddress } from '../../utils/constant';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';
import EN from '../../../EN.json';
import FR from '../../../FR.json';
import { useLocaleContext } from '../../context/LocaleContext';

const FieldDate = ({ data, orderData }) => {
  const {
    value,
    placeholder,
    label,
    onChange,
    name,
    required,
    fieldDateConfig,
    readonly,
    tooltip,
    tooltipLong,
    toolTipRichText,
    isLabelBold
  } = data;
  const localizedStrings = useLocalizedStringsContext();
  const local = useLocaleContext();
  const { contentfulValues: { valueQuebec } = {} } =
    local === 'en-US' ? EN : FR;
  const {
    contentfulValues: {
      yes,
      no,
    }
  } = localizedStrings;
  const config = {};
  if (typeof fieldDateConfig.minDays !== 'undefined') {
    config.minDate = subBusinessDays(new Date(), fieldDateConfig.minDays);
  }
  if (typeof fieldDateConfig.maxDays !== 'undefined') {
    config.maxDate = addBusinessDays(new Date(), fieldDateConfig.maxDays);
  }
  const valueIsTheirAnyReasonToGoThroughMySOF = get(orderData, filedIsTheirAnyReasonToGoThroughMySOF, '') === yes;

const valueWLSBusinessConnect = get(orderData, fieldWLSBusinessConnect, '') === no;
const valueIsEContractCustomer = get(orderData, fieldIsThisAnEContractCustomer, '') === no;
const valueNeedMoreThanSingleServiceAddress = get(orderData, filedNeedMoreThanSingleServiceAddress, '') === no;
const valueNeedMediaAdvertisingBilling = get(orderData, filedNeedMediaAdvertisingBilling, '') === no;

  const isAllValuesNoOdyssey = valueWLSBusinessConnect && valueIsEContractCustomer && valueNeedMoreThanSingleServiceAddress &&
  valueNeedMediaAdvertisingBilling;
  /**
   * Rule: Preferred Installation should be more then 15 business days
   * from the order creation date
   */
  // if (name === fieldPreferredInstallationDate) {
  //   config.minDate = addBusinessDays(new Date(orderData.createdAt), 15);
  // }
  if (name === fieldPreferredInstallDate1 || name === fieldPreferredInstallDate2 || name === fieldPreferredInstallDate3 && isAllValuesNoOdyssey) {
    config.minDate = addBusinessDays(new Date(orderData.createdAt), 7);
  }
  const tooltipMessage = tooltip || tooltipLong || toolTipRichText;

  const isDayDisabled = (day) => {
    if (config.minDate && day.isBefore(moment(config.minDate), 'day')) return true;
    if (config.maxDate && day.isAfter(moment(config.maxDate), 'day')) return true;
    return false;
  };

  return (
    <FieldWrapper>
      <div>
        <FieldLabelWrapper>
          <FieldTitle required={required} label={label} isLabelBold={isLabelBold} />
          {tooltipMessage && (
            <FieldGuide tooltip={tooltipMessage} isRichText={toolTipRichText} />
          )}
        </FieldLabelWrapper>
      </div>
      {/* onFocus dispatches a scroll event so the UDS DatePicker's portal
          recalculates its position (fixes calendar appearing at 0,0 when
          the input was inside a collapsed ExpandCollapse panel on mount) */}
      <div onFocus={() => window.dispatchEvent(new Event('scroll'))}>
        <ManagedDatePicker
          id={`field-date-${name}`}
          label=""
          hint={placeholder}
          disabled={readonly}
          value={value || ''}
          onValueChange={(v) => {
            onChange({
              target: {
                name,
                value: v
              }
            });
          }}
          isDayDisabled={isDayDisabled}
          dateFormat="YYYY/MM/DD"
          initialVisibleMonth={config.minDate ? moment(config.minDate).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')}
          tooltip={typeof tooltipMessage === 'string' ? tooltipMessage : undefined}
          copy={local === 'fr-CA' ? 'fr' : 'en'}
        />
      </div>
    </FieldWrapper>
  );
};

FieldDate.propTypes = {
  orderData: PropTypes.objectOf(PropTypes.any).isRequired,
  data: PropTypes.shape({
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    name: PropTypes.string.isRequired,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    required: PropTypes.bool,
    onChange: PropTypes.func.isRequired,
    fieldDateConfig: PropTypes.shape({
      minDays: PropTypes.number,
      maxDays: PropTypes.number
    }),
    readonly: PropTypes.bool,
    tooltip: PropTypes.string,
    tooltipLong: PropTypes.string,
    toolTipRichText: PropTypes.shape({
      content: PropTypes.arrayOf(PropTypes.object)
    }),
    isLabelBold: PropTypes.bool
  }).isRequired
};

export default FieldDate;
